import { createFileRoute, redirect } from "@tanstack/react-router";
import { meQueryOptionsFor } from "@/hooks/useCloudChat";

// Studies is the app home; the bare root forwards there so old links (and the
// many `to: "/"` navigations) keep working. Orgs without studies land on Chats
// instead — `ensureStudiesEnabled` bounces them back to "/", so sending them to
// /studies would redirect-loop.
export const Route = createFileRoute("/_auth/_agents/")({
  beforeLoad: async ({ context, preload }) => {
    const me = await context.queryClient.ensureQueryData(meQueryOptionsFor(preload));
    throw redirect({ to: me.studies_enabled ? "/studies" : "/chats" });
  },
});
